import ModalABCValues from 'components/Modal/ABCValues';
import ModalBaseAdd from 'components/Modal/BaseAdd';
import ModalBaseSelect from 'components/Modal/BaseSelect';
import ModalBaseVersionSelect from 'components/Modal/BaseVersionSelect';
import ModalBudgetBaseAdd from 'components/Modal/BudgetBaseAdd';
import ModalBudgetComponentBDI from 'components/Modal/BudgetComponentBDI';
import ModalBudgetComponentObservation from 'components/Modal/BudgetComponentObservation';
import ModalBudgetCompositionEdit from 'components/Modal/BudgetCompositionEdit';
import ModalBudgetCompositionFragmentSelect from 'components/Modal/BudgetCompositionFragmentSelect';
import ModalBudgetCompositionLookup from 'components/Modal/BudgetCompositionLookup';
import ModalBudgetCompositionSelect from 'components/Modal/BudgetCompositionSelect';
import ModalBudgetConversionToSienge from 'components/Modal/BudgetConversionToSienge';
import ModalBudgetCustomBDI from 'components/Modal/BudgetCustomBDI';
import ModalBudgetCustomCompositionAdd from 'components/Modal/BudgetCustomCompositionAdd';
import ModalBudgetGlobalPriceChange from 'components/Modal/BudgetGlobalPriceChange';
import ModalBudgetHistory from 'components/Modal/BudgetHistory';
import ModalBudgetImport from 'components/Modal/BudgetImport';
import ModalBudgetImportFields from 'components/Modal/BudgetImport/Fields';
import ModalBudgetImportOverview from 'components/Modal/BudgetImport/Overview';
import ModalBudgetInputFragmentSelect from 'components/Modal/BudgetInputFragmentSelect';
import ModalBudgetInputSelect from 'components/Modal/BudgetInputSelect';
import ModalBudgetOutdatedComponentSelect from 'components/Modal/BudgetOutdatedComponentSelect';
import ModalBudgetSuggestedCompositionLink from 'components/Modal/BudgetSuggestedCompositionLink';
import ModalBudgetTypeSelect from 'components/Modal/BudgetTypeSelect';
import ModalBulkEditInputs from 'components/Modal/BulkEditInputs';
import ModalClientLookup from 'components/Modal/ClientLookup';
import ModalClientAdd from 'components/Modal/ClientAdd';
import ModalClientSelfLookup from 'components/Modal/ClientSelfLookup';
import ModalCompositionGroupsLookup from 'components/Modal/CompositionGroupsLookup';
import ModalCompositionLookup from 'components/Modal/CompositionLookup';
import ModalCustomCompositionMassUpdate from 'components/Modal/CustomCompositionMassUpdate';
import ModalDNITCompositionLookup from 'components/Modal/DNITCompositionLookup';
import ModalEnterpriseLookup from 'components/Modal/EnterpriseLookup';
import ModalFlowStatusAction from 'components/Modal/FlowActionAdd';
import ModalFlowStatusAdd from 'components/Modal/FlowStatusAdd';
import ModalGPTModel from 'components/Modal/GPTModel';
import ModalImport from 'components/Modal/Import';
import ModalImportCompositionFields from 'components/Modal/Import/Composition/Fields';
import ModalImportCompositionOverview from 'components/Modal/Import/Composition/Overview';
import ModalImportInputFields from 'components/Modal/Import/Input/Fields';
import ModalImportInputOverview from 'components/Modal/Import/Input/Overview';
import ModalJSONViewer from 'components/Modal/JSONViewer';
import ModalLocaleAndPriceTypeSelect from 'components/Modal/LocaleAndPriceTypeSelect';
import ModalManageFlow from 'components/Modal/ManageFlow';
import ModalManageParametricFlow from 'components/Modal/ManageParametricFlow';
import ModalOwnCompositionSelect from 'components/Modal/OwnCompositionSelect';
import ModalOwnInputSelect from 'components/Modal/OwnInputSelect';
import ModalParametricBudgetHistory from 'components/Modal/ParametricBudgetHistory';
import ModalParametricBudgetLookup from 'components/Modal/ParametricBudgetLookup';
import ModalPaymentCategoryLookup from 'components/Modal/PaymentCategoryLookup';
import ModalPositionUpdate from 'components/Modal/PositionUpdate';
import ModalSiengeBudgetCustomCompositionAdd from 'components/Modal/SiengeBudgetCustomCompositionAdd';
import ModalSiengeImportSummary from 'components/Modal/SiengeImportSummary';
import ModalSiengeOrganizationLookup from 'components/Modal/SiengeOrganizationLookup';
import ModalStageAdd from 'components/Modal/StageAdd';
import ModalSubscriptionHistory from 'components/Modal/SubscriptionHistory';
import ModalSupport from 'components/Modal/Support';
import ModalTrademarkLookup from 'components/Modal/TrademarkLookup';
import ModalTrademarksAndDetailsLookup from 'components/Modal/TrademarksAndDetails';
import ModalUnitConstructiveAdd from 'components/Modal/UnitConstructiveAdd';
import ModalUnitConstructiveLookup from 'components/Modal/UnitConstructiveLookup';
import ModalUnitCostImportLookup from 'components/Modal/UnitCostImportLookup';
import ModalUnitCostLookup from 'components/Modal/UnitCostLookup';
import ModalUnitMeasureAdd from 'components/Modal/UnitMeasureAdd';
import ModalUserInvite from 'components/Modal/UserInvite';
import ModalUserOrganizationLookup from 'components/Modal/UserOrganizationLookup';
import ModalVersionAdd from 'components/Modal/VersionAdd';
import ModalBudgetLookup from 'components/Modal/BudgetLookup';
import ModalBudgetPlanningPreview from 'components/Modal/BudgetPlanningPreview';
import ModalAutomaticLinkStrategySelect from 'components/Modal/AutomaticLinkStrategySelect';
import ModalOpportunityAdd from 'components/Modal/OpportunityAdd';

export default {
  baseAdd: ModalBaseAdd,
  baseSelect: ModalBaseSelect,
  versionAdd: ModalVersionAdd,
  clientLookup: ModalClientLookup,
  clientAdd: ModalClientAdd,
  clientSelfLookup: ModalClientSelfLookup,
  compositionLookup: ModalCompositionLookup,
  budgetCompositionLookup: ModalBudgetCompositionLookup,
  userInvite: ModalUserInvite,
  budgetCompositionSelect: ModalBudgetCompositionSelect,
  budgetSuggestedCompositionLink: ModalBudgetSuggestedCompositionLink,
  budgetCompositionFragmentSelect: ModalBudgetCompositionFragmentSelect,
  budgetComponentObservation: ModalBudgetComponentObservation,
  budgetInputSelect: ModalBudgetInputSelect,
  budgetInputFragmentSelect: ModalBudgetInputFragmentSelect,
  bulkEditInputs: ModalBulkEditInputs,
  stageAdd: ModalStageAdd,
  positionUpdate: ModalPositionUpdate,
  ownCompositionSelect: ModalOwnCompositionSelect,
  ownInputSelect: ModalOwnInputSelect,
  import: ModalImport,
  inputImportFields: ModalImportInputFields,
  compositionImportFields: ModalImportCompositionFields,
  importInputOverview: ModalImportInputOverview,
  importCompositionOverview: ModalImportCompositionOverview,
  budgetCompositionEdit: ModalBudgetCompositionEdit,
  subscriptionHistory: ModalSubscriptionHistory,
  userOrganizationLookup: ModalUserOrganizationLookup,
  abcValues: ModalABCValues,
  support: ModalSupport,
  budgetTypeSelect: ModalBudgetTypeSelect,
  enterpriseLookup: ModalEnterpriseLookup,
  unitConstructiveLookup: ModalUnitConstructiveLookup,
  jsonViewer: ModalJSONViewer,
  siengeOrganizationLookup: ModalSiengeOrganizationLookup,
  flowChange: ModalManageFlow,
  budgetHistory: ModalBudgetHistory,
  parametricFlowChange: ModalManageParametricFlow,
  parametricBudgetHistory: ModalParametricBudgetHistory,
  gptModel: ModalGPTModel,
  unitConstructiveAdd: ModalUnitConstructiveAdd,
  parametricBudgetLookup: ModalParametricBudgetLookup,
  budgetCustomCompositionAdd: ModalBudgetCustomCompositionAdd,
  budgetConversionToSienge: ModalBudgetConversionToSienge,
  budgetOutdatedComponentSelect: ModalBudgetOutdatedComponentSelect,
  localeAndPriceTypeSelect: ModalLocaleAndPriceTypeSelect,
  budgetGlobalPriceChange: ModalBudgetGlobalPriceChange,
  budgetCustomBDI: ModalBudgetCustomBDI,
  budgetComponentBDI: ModalBudgetComponentBDI,
  baseVersionSelect: ModalBaseVersionSelect,
  budgetImport: ModalBudgetImport,
  budgetImportFields: ModalBudgetImportFields,
  budgetBaseAdd: ModalBudgetBaseAdd,
  budgetImportOverview: ModalBudgetImportOverview,
  unitMeasureAdd: ModalUnitMeasureAdd,
  unitCostLookup: ModalUnitCostLookup,
  paymentCategoryLookup: ModalPaymentCategoryLookup,
  trademarksAndDetailsLookup: ModalTrademarksAndDetailsLookup,
  trademarksLookup: ModalTrademarkLookup,
  customCompositionMassUpdate: ModalCustomCompositionMassUpdate,
  unitCostImportLookup: ModalUnitCostImportLookup,
  siengeImportSummary: ModalSiengeImportSummary,
  flowStatusAdd: ModalFlowStatusAdd,
  flowActionAdd: ModalFlowStatusAction,
  compositionGroupsLookup: ModalCompositionGroupsLookup,
  dnitCompositionLookup: ModalDNITCompositionLookup,
  siengeBudgetCustomCompositionAdd: ModalSiengeBudgetCustomCompositionAdd,
  budgetLookup: ModalBudgetLookup,
  budgetPlanningPreview: ModalBudgetPlanningPreview,
  automaticLinkStrategySelect: ModalAutomaticLinkStrategySelect,
  opportunityAdd: ModalOpportunityAdd,
};
